export default "__VITE_ASSET__CL0H9853__"